module.exports = __webpack_public_path__ + "static/media/Union.42109e9c.svg";